import React from 'react'

const More = ({ information }) => {
    return (
        <a href={information.provider.urlWebsite}
            className='
                border-button
                text-brand-tertiary-500
                hover:text-white
                rounded-full
                flex
                items-center
                justify-center
                py-2
                border
                border-brand-primary-500
                hover:bg-brand-primary-500
                transition-all
                duration-500'
            rel="noreferrer"
            target={'_blank'}
        >
            Weitere Informationen
        </a>
    )
}

export default More
